/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getData } from 'common/utils'
import { Row, Col } from 'components/ui'
// import Pagination from '@mui/material/Pagination'
// import AlertDialog from 'components/ui/AlertDialog'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import InputAdornment from '@mui/material/InputAdornment'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import TextField from '@mui/material/TextField'
// import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import Button from 'components/form/Button'
import AddIcon from '@mui/icons-material/Add'
import CheckIcon from '@mui/icons-material/Check'
import { Link } from 'react-router-dom'
import { Table } from 'antd'
// import { toast } from 'react-toastify'
import 'antd/lib/table/style/index.css'
import 'antd/lib/dropdown/style/index.css'
import 'antd/lib/checkbox/style/index.css'
import 'antd/lib/input/style/index.css'
import 'antd/lib/button/style/index.css'
import 'antd/lib/space/style/index.css'
import 'antd/lib/pagination/style/index.css'
import '../styles/static-page.scss'

// const { Option } = Select

const StaticPage = (props) => {
  // const queryClient = useQueryClient()

  // const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [total, setTotal] = useState(0)
  // const [totalPage, setTotalPage] = useState(1)
  // const [limit, setLimit] = useState(10)
  // const [current, setCurrent] = useState(1)
  // const [offset, setOffset] = useState(0)
  const [data, setData] = useState([])
  // const [idDelete, setIdDelete] = useState(null)

  const [searchText, setSearchText] = useState('')
  const [searchTextFilter, setSearchTextFilter] = useState('')

  // const pageList = [
  //   { value: 10, label: '10 / page' },
  //   { value: 20, label: '20 / page' },
  //   { value: 50, label: '50 / page' }
  // ]

  // const { data: dataList, isLoading, isFetching } = useQuery(['getStaticPage', limit, offset], async () => {
  //   return await getData('GET', `tenants/${localStorage.getItem('tenant')}/static_page/?limit=${limit}&offset=${offset}`)
  // })

  const { data: dataList, isLoading, isFetching } = useQuery(['getStaticPage', searchTextFilter], async () => {
    if (searchTextFilter !== '') {
      return await getData('GET', `tenants/${localStorage.getItem('tenant')}/static_page?title=${searchTextFilter}`)
    } else {
      return await getData('GET', `tenants/${localStorage.getItem('tenant')}/static_page`)
    }
  })

  // const mutationDelete = useMutation(async (id) => {
  //   if (id) {
  //     return await getData('DELETE', `static_page/${id}/`)
  //   }
  // }, {
  //   onSuccess: () => {
  //     queryClient.invalidateQueries('getStaticPage')
  //   }
  // })

  const columns = [
    {
      title: 'Action',
      key: 'operation',
      fixed: 'left',
      align: 'center',
      width: '10%',
      // eslint-disable-next-line react/display-name
      render: (text, record, index) => {
        return (
          <div>
            {/* <Tooltip title="Delete">
              <IconButton color="error" onClick={e => handleClickShowModalDelete(e, record)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip> */}
            <Tooltip title="Edit">
              <Link to={`/static-page/${record.id}`}>
                <IconButton color="success">
                  <EditIcon />
                </IconButton>
              </Link>
            </Tooltip>
          </div>
        )
      }
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      width: '30%'
    },
    {
      title: 'Slug',
      dataIndex: 'slug',
      key: 'slug',
      width: '30%'
    },
    {
      title: 'Updated at',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: '15%'
    },
    {
      title: 'Active',
      key: 'is_active',
      align: 'center',
      width: '15%',
      // eslint-disable-next-line react/display-name
      render: (text, record, index) => {
        if (record && record.is_active) {
          return <CheckIcon color="success" />
        } else {
          return null
        }
      }
    }
  ]

  // useEffect(() => {
  //   if (dataList && limit) {
  //     console.log(dataList)
  //     let resultData = []
  //     const dataListData = dataList.data

  //     if (dataListData) {
  //       if (Array.isArray(dataListData)) {
  //         resultData = dataListData
  //         setTotal(dataListData.length)
  //         setTotalPage(Math.ceil(dataListData.length / limit))
  //       } else {
  //         resultData = dataListData.results
  //         setTotal(dataListData.total)
  //         setTotalPage(Math.ceil(dataListData.total / limit))
  //       }
  //     }

  //     if (Array.isArray(resultData)) {
  //       const dataListParse = resultData.map(item => {
  //         return {
  //           key: item.id,
  //           ...item
  //         }
  //       })

  //       setData(dataListParse)
  //     }
  //   }
  // }, [dataList, limit])

  useEffect(() => {
    if (dataList) {
      let resultData = []
      const dataListData = dataList.data

      if (dataListData) {
        if (Array.isArray(dataListData)) {
          resultData = dataListData
          setTotal(dataListData.length)
          // setTotalPage(Math.ceil(dataListData.length / limit))
        } else {
          resultData = dataListData.results
          setTotal(dataListData.total)
          // setTotalPage(Math.ceil(dataListData.total / limit))
        }
      }

      if (Array.isArray(resultData)) {
        const dataListParse = resultData.map(item => {
          return {
            key: item.id,
            ...item
          }
        })

        setData(dataListParse)
      }
    }
  }, [dataList])

  /* ----------------------------------------------- */
  /* --------------- Handle Event ------------------ */
  /* ----------------------------------------------- */
  // const handleClickShowModalDelete = (e, record) => {
  //   setIdDelete(record.id)
  //   setIsOpenDelete(true)
  // }

  // const handleCloseDelete = () => {
  //   setIsOpenDelete(false)
  // }

  // const handleChangePage = (event, value) => {
  //   setCurrent(value)
  //   setOffset((value - 1) * limit)
  // }

  // const handleChangeLimit = (value) => {
  //   setLimit(value)
  //   setCurrent(0)
  //   setOffset(0)
  // }

  // const handleClickDelete = async () => {
  //   try {
  //     await mutationDelete.mutateAsync(idDelete)

  //     setIsOpenDelete(false)
  //     toast.success('Comment deleted successfully')
  //   } catch (err) {
  //     setIsOpenDelete(false)
  //     toast.error('Something went wrong!')
  //     console.log(err)
  //   }
  // }

  const handleChangeSearch = (e) => {
    setSearchText(e.target.value)
  }

  const handleClickSearch = () => {
    setSearchTextFilter(searchText)
  }

  const handleClearSearch = () => {
    setSearchText('')
    setSearchTextFilter('')
  }

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      setSearchTextFilter(searchText)
    }
  }

  return (
    <div className="static-page">
      <Card>
        <CardContent>
          <Row className="pt-2">
            <Col md={5}>
              <TextField
                size="small"
                fullWidth
                label="Search by title"
                variant="standard"
                value={searchText}
                onChange={handleChangeSearch}
                onKeyDown={handleEnter}
                InputProps={{
                  endAdornment: (
                    <>
                      {searchText !== '' &&
                        <InputAdornment position="end">
                          <IconButton onClick={handleClearSearch}>
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                      <InputAdornment position="end">
                        <IconButton onClick={handleClickSearch}>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    </>
                  )
                }}
              />
            </Col>
          </Row>
        </CardContent>
      </Card>

      <Row className="pt-4 pb-1">
        <Col md={12}>
          <Link to={'/static-page/add'}>
            <Button className="float-right" startIcon={<AddIcon />}>
              Add New
            </Button>
          </Link>
        </Col>
      </Row>
      <Row className="pb-1">
        <Col md={12}>
          <div className="total-text">Total: {total}</div>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Table
            columns={columns}
            dataSource={data}
            scroll={{
              x: 1000
            }}
            bordered
            pagination={false}
            loading={isLoading || isFetching}
          />
        </Col>
      </Row>

      {/* <Row className="pt-4">
        <Col md={12}>
          <Select className="float-right ml-4" value={limit} onChange={handleChangeLimit} style={{ width: 110 }}>
            {pageList && pageList.map((item, index) => {
              return (
                <Option key={index} value={item.value}>{item.label}</Option>
              )
            })}
          </Select>

          <Pagination
            className="float-right"
            count={totalPage}
            page={current}
            onChange={handleChangePage}
            showFirstButton
            showLastButton
            variant="outlined"
            shape="rounded"
            color="standard"
          />
        </Col>
      </Row> */}

      {/* <AlertDialog
        isOpen={isOpenDelete}
        type="delete"
        title="Notification"
        contentText="This action cannot be undone. Are you sure you want to delete this item?"
        onClose={handleCloseDelete}
        onSave={handleClickDelete}
      /> */}
    </div>
  )
}

export default StaticPage
